import { deleteEvent } from '@dispatch/shared/services';
import { useMutate } from '../api/useMutate';
import { useQueryClient } from 'react-query';

export const useDeleteEvent = (
  responseFn: (data: { success: boolean }) => void | Promise<unknown>
) => {
  const queryClient = useQueryClient();
  const { mutate, error, status } = useMutate(
    'delete-resource-event',
    (data: { resourceId: string; eventId: string }) => deleteEvent(data),
    (data) => {
      queryClient.invalidateQueries(['schedule-data']);
      queryClient.invalidateQueries(['schedule-data-infinite']);
      responseFn(data as { success: boolean });
    }
  );

  return {
    deleteEvent: mutate,
    error,
    status,
  };
};
